import { BaseResponse } from '../common';
import { CompanyId } from '../companies';
import { GraphId } from '../graph';
import { CompanyPolicyId, FolderId } from '../library';
import { ProgramId } from '../programs';

export type AdminScaleId = string;
export type AdminScaleChildId = string;
export interface AccountResponse {
  companyId: CompanyId;
  title: string;
  appId: string;
}

export interface AdminScaleResponse extends BaseResponse {
  id: AdminScaleId;
  title: string;
}

export enum AdminScaleChildType {
  goals = 'goals',
  purposes = 'purposes',
  policy = 'policy',
  plans = 'plans',
  programs = 'programs',
  orders = 'orders',
  idealScenes = 'ideal scenes',
  statistics = 'statistics',
  valuableFinalProducts = 'valuable final products',
}

export const adminScaleChildTypes = [
  AdminScaleChildType.goals,
  AdminScaleChildType.purposes,
  AdminScaleChildType.policy,
  AdminScaleChildType.plans,
  AdminScaleChildType.programs,
  AdminScaleChildType.orders,
  AdminScaleChildType.idealScenes,
  AdminScaleChildType.statistics,
  AdminScaleChildType.valuableFinalProducts,
];

export interface TreeNode extends BaseResponse {
  id: AdminScaleChildId;
  type: AdminScaleChildType;
  data?: AdminScaleChildResponse[];
}

export interface AdminScaleChildResponse extends BaseResponse {
  id: AdminScaleChildId;
  adminScaleId: AdminScaleId;
  name: string;
  purpose?: string;
  type: AdminScaleChildType;
  description: string | null;
  menuOrder: number;
  assignees?: string[];
  programId: ProgramId;
  policyId: CompanyPolicyId;
  statId: GraphId;
  folderId: FolderId;
}

export interface AdminScaleChildPolicyResponse extends BaseResponse {
  id: CompanyPolicyId;
  name: string;
}

export interface AdminScaleChildBoardItem {
  id: string;
  menuOrder: number;
  name: string;
  cards: AdminScaleChildResponse[];
}

export interface AdminScaleBoardType {
  columns: AdminScaleChildBoardItem[];
}

export type CompactAdminScaleResponse = Pick<AdminScaleResponse, 'id' | 'title'>;
